(function () {
(function($) {
    const behavior = "polyu_theme.ranking";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{}
    };
    $(function() {
        const currentURL = window.location.href;
        // Change  indexOf("x") to what the url contains i.e. pg/ug
        if (currentURL.indexOf("pg") > -1) {
            var element = $(".paragraph--ranking");
            element.addClass("pg-version");
        }
    });
    $(function() {
        const swiper = new Swiper(".swiper", {
            direction: "horizontal",
            loop: true,
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    centeredSlides: true
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 17,
                    centeredSlides: false
                },
                1368: {
                    slidesPerView: 3,
                    spaceBetween: 17
                }
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    });
})(jQuery);

})();
//# sourceMappingURL=paragraph--ranking.js.map
